/**
 * This component renders the sidebar for a game page
 * WARNING - Currently using some dummy data
 */
import React from "react";
import StatsBarSection from "./StatsBarSection";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ProfileImageContainer from "../core/ProfileImageContainer.js";
import { Link } from "react-router-dom";
import Loading from "../core/Loading.js";
import { formatEpochDate } from "../utils/time.js";
import GameDetails from "./GameDetails";



const processSidebarData = (jsonData) => {
  // preprocessing for team stats
  const gapSize = 1.5;

  jsonData.home_sog_pct =
    (jsonData.boxscore["T"]["home_shots"] /
      (jsonData.boxscore["T"]["home_shots"] +
        jsonData.boxscore["T"]["away_shots"])) *
      100;
  jsonData.away_sog_pct =
    (jsonData.boxscore["T"]["away_shots"] /
      (jsonData.boxscore["T"]["home_shots"] +
        jsonData.boxscore["T"]["away_shots"])) *
      100;

  if (!((jsonData.home_sog_pct === 100) || (jsonData.away_sog_pct === 100))) {
    jsonData.home_sog_pct -= gapSize;
    jsonData.away_sog_pct -= gapSize;
  }

  jsonData.home_acc =
    jsonData.boxscore["T"]["home_goals"] / jsonData.boxscore["T"]["home_shots"];
  jsonData.away_acc =
    jsonData.boxscore["T"]["away_goals"] / jsonData.boxscore["T"]["away_shots"];

  jsonData.home_acc_pct =
    (jsonData.home_acc / (jsonData.home_acc + jsonData.away_acc)) * 100;
  jsonData.away_acc_pct =
    (jsonData.away_acc / (jsonData.home_acc + jsonData.away_acc)) * 100;

  if (!(jsonData.home_acc === 100 || jsonData.away_acc === 100)) {
    jsonData.home_acc_pct -= gapSize;
    jsonData.away_acc_pct -= gapSize;
  }

  jsonData.home_pim_pct =
    (jsonData.boxscore["T"]["home_penalties"] /
      (jsonData.boxscore["T"]["home_penalties"] +
        jsonData.boxscore["T"]["away_penalties"])) *
      100
  jsonData.away_pim_pct =
    (jsonData.boxscore["T"]["away_penalties"] /
      (jsonData.boxscore["T"]["home_penalties"] +
        jsonData.boxscore["T"]["away_penalties"])) *
      100
  if (!(jsonData.home_pim_pct === 100 || jsonData.away_pim_pct === 100)) {
    jsonData.home_pim_pct -= gapSize;
    jsonData.away_pim_pct -= gapSize;
  }

  jsonData.home_ppe = jsonData.hpp / (jsonData.hpps / 60);
  jsonData.away_ppe = jsonData.app / (jsonData.apps / 60);

  jsonData.home_ppe_pct =
    (jsonData.home_ppe / (jsonData.home_ppe + jsonData.away_ppe)) * 100;
  jsonData.away_ppe_pct =
    (jsonData.away_ppe / (jsonData.home_ppe + jsonData.away_ppe)) * 100;

  if (!jsonData.home_ppe === 100 && !jsonData.away_ppe === 100) {
    jsonData.home_ppe_pct -= gapSize;
    jsonData.away_ppe_pct -= gapSize;
  }
  
  if (isNaN(jsonData.home_ppe)) jsonData.home_ppe = " - ";
  else if (jsonData.hpps ===0) jsonData.home_ppe = " - ";
  else jsonData.home_ppe = jsonData.home_ppe.toFixed(2);

  if (isNaN(jsonData.away_ppe)) jsonData.away_ppe = " - ";
  else if (jsonData.apps ===0) jsonData.away_ppe = " - ";
  else jsonData.away_ppe = jsonData.away_ppe.toFixed(2);

  jsonData.home_bench_pct =
    (jsonData.home_bench / (jsonData.home_bench + jsonData.away_bench)) * 100 -
    gapSize;
  jsonData.away_bench_pct =
    (jsonData.away_bench / (jsonData.home_bench + jsonData.away_bench)) * 100 -
    gapSize;

  return jsonData;
};

const SidebarContent = (game_data) => {
  let headless = game_data.headless;
  game_data = game_data.game_data;

  // const { gameId } = useParams();
  const { isLoading, error, data } = useQuery({
    staleTime: 3600000,
    queryKey: ["game", game_data.id, "detail"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/game/${game_data.id}/detail/`)
        .then((res) => res.json())
        .then((json) => {
          let sidebar_data = processSidebarData(json);
          return sidebar_data;
        }),
  });

  if (isLoading)
    return (
      <>
        <div className="sidebar flex flex-col justify-center items-center m-1 mx-4 pt-4 mb-8 xl:mr-8 xl:px-0 px-4">
          <Loading />
        </div>
      </>
    );
    
  if (error) return "An error has occurred: " + error.message;

  const gradientStyle = {
    background: `linear-gradient(to right, ${game_data.home_team.primary_color}, ${game_data.away_team.primary_color})`,
  };

  if (headless === true) {
    return <div className="mb-10">
      <GameDetails game_data={game_data} sidebar_data={data}></GameDetails>
    </div>
  } else {
    return (
        <div className="sidebar flex flex-col items-center justify-start w-auto xs:m-1 xs:mx-4 pt-4 xs:mb-4 xl:mr-8 xl:px-0 px-2 xxs:px-4 mb-8">
          <div className="max-w-[800px] w-full">
            <GameDetails game_data={game_data} sidebar_data={data}></GameDetails>
          </div>
        </div>
    );
  }
};

export default SidebarContent;
